import { ContentProps } from '@components/CreditCardContent/components/Content.interface'
import balanceTransferOfferDurationContent from '@components/CreditCardContent/components/balanceTransferOfferDurationContent'
import guaranteedAprContent from '@components/CreditCardContent/components/guaranteedAprContent'
import minimumGuaranteedCreditLimitContent from '@components/CreditCardContent/components/minimumGuaranteedCreditLimitContent'
import noMinimumGuaranteedCreditLimitContent from '@components/CreditCardContent/components/noMinimumGuaranteedCreditLimitContent'
import purchaseOfferDurationContent from '@components/CreditCardContent/components/purchaseOfferDurationContent'
import representativeAprContent from '@components/CreditCardContent/components/representativeAprContent'
import transferFeeContent from '@components/CreditCardContent/components/transferFeeContent'

const getCombinedContent = ({ creditCard }: ContentProps) => {
    return [
        guaranteedAprContent({ creditCard }),
        representativeAprContent({ creditCard }),
        minimumGuaranteedCreditLimitContent({ creditCard }),
        noMinimumGuaranteedCreditLimitContent({
            creditCard,
        }),
        balanceTransferOfferDurationContent({ creditCard }),
        purchaseOfferDurationContent({ creditCard }),
        transferFeeContent({ creditCard }),
    ]
}

export default getCombinedContent
